import { IonContent, IonPage } from '@ionic/react';
import { HomeContent } from '../components/ui/HomeContent';

const HomePage = () => {
  return (
    <IonPage>
      <IonContent className="ion-padding bg-white">
        <HomeContent />
      </IonContent>
    </IonPage>
  );
};

export default HomePage;
